import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchContactTypes } from 'features/shared/contacts/ContactTypesActions';
import { selectContactTypesLoaded } from 'features/shared/contacts/ContactTypesSlice';

// Global reference data — always refetched on mount (cheap GET), so a
// catalog change (new/renamed contact type) is picked up without a full
// app restart.
export const useFetchContactTypes = (): boolean => {
  const dispatch = useDispatch();
  const loaded = useSelector(selectContactTypesLoaded());

  useEffect(() => {
    dispatch(fetchContactTypes());
  }, [dispatch]);

  return loaded;
};
